import { LineItem, Lot } from 'types';
import { calcTotalBaselinePrice } from './calcTotalBaselinePrice';

export const calcEventBaselinePrice = (lots?: Lot[], isCounted?: (_item: LineItem) => boolean): number => {
  if (!lots?.length) return 0.0;

  return lots.reduce((acc, lot) => acc + calcTotalBaselinePrice(lot, isCounted), 0);
};
